export enum Types {
	CONSULTA_DOCUMENTOS_REQUEST = '@iirgd/CONSULTA_DOCUMENTOS_REQUEST',
	CONSULTA_DOCUMENTOS_SUCCESS = '@iirgd/CONSULTA_DOCUMENTOS_SUCCESS',
	CONSULTA_DOCUMENTOS_FAILURE = '@iirgd/CONSULTA_DOCUMENTOS_FAILURE',
	LIMPA_CONSULTA_DOCUMENTOS = '@iirgd/LIMPA_CONSULTA_DOCUMENTOS',
}

export interface consultaDocumentos {
	status: number;
	data: null | ConsultaDocumentos;
}

export interface ConsultaDocumentos {
	urlArquivo: string;
}

export interface IRequestPesquisaCita {
	rg: string;
	cpf: string;
}
